import {query} from "@solidjs/router";
import api from "~/api/api";
import {PetResponse, PetCreateRequest} from "@tag-tails/types";

export const getPet = query(async (id: string): Promise<PetResponse | null> => {
    "use server"
    try {
        const res = await api.get<PetResponse>(`/pets/${id}`)
        return res.data
    } catch (e) {
        return null
    }
}, "petById")

export const getPetsByOwner = query(async (id: string): Promise<Array<PetResponse> | null> => {
    "use server"
    try {
        const res = await api.get<Array<PetResponse>>(`/pets?owner=${id}`);
        return res.data
    } catch (e) {
        return null
    }
}, "petsByOwner")

export async function updatePet(pet: PetResponse): Promise<PetResponse | null> {
    "use server"
    try {

        const res = await api.put<PetResponse>(`/pets/${pet.id}`, pet)
        return res.data
    } catch (e) {
        return null
    }
}

export async function createPet(pet: PetCreateRequest): Promise<PetResponse | null> {
    "use server"
    try {
        const res = await api.post<PetResponse>(`/pets`, pet)
        return res.data
    } catch (e) {
        return null
    }
}

export async function deletePet(id: string): Promise<void> {
    "use server"
    try {
        await api.delete(`/pets/${id}`)
    } catch (e) {
    }
}
